import { z } from 'zod';
export const NivelFullSchema = z.object({
    id: z.number(),
    disciplinaClave: z.string(),
    disciplinaNombre: z.string(),
    nombre: z.string(),
    orden: z.number().nullable().optional(),
    descripcion: z.string().nullable().optional(),
    activo: z.boolean(),
});
export const NivelFormSchema = z.object({
    disciplina: z.string().min(1, 'Requerida'),
    nombre: z.string().trim().min(1, 'Requerido').max(50),
    orden: z.coerce.number().int().min(0).max(1000),
    descripcion: z.string().max(2000).optional().or(z.literal('')),
});
export const NivelValorSchema = z.object({
    id: z.string().uuid(),
    nivelId: z.number(),
    valorHora: z.union([z.string(), z.number()]),
    fechaInicio: z.string(),
    fechaFin: z.string().nullable().optional(),
});
export const NivelValorFormSchema = z.object({
    valorHora: z.string().regex(/^\d+(\.\d{1,2})?$/, 'Monto inválido'),
    fechaInicio: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'YYYY-MM-DD'),
});
